module.exports = "<div class=\"c-radio\" ng-repeat=\"(key, option) in to.options\" >\n  <input type=\"radio\"\n         class=\"c-radio__input\"\n         id=\"{{id + '_'+ option[to.valueProp || 'value']}}\"\n         tabindex=\"0\"\n         ng-disabled=\"option.isDisabled()\"\n         ng-value=\"option[to.valueProp || 'value']\"\n         ng-model=\"model[options.key]\">\n  <label class=\"c-radio__label\" for=\"{{id + '_'+ option[to.valueProp || 'value']}}\">\n    <span class=\"c-radio__box\" gg-icon=\"icon-radio\"></span>\n    <span class=\"c-radio__mark\" gg-icon=\"icon-radio-mark\"></span>\n    {{option[to.labelProp || 'name']}}\n  </label>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/radio.html
 ** module id = 543
 ** module chunks = 0
 **/